import getNetResource from './netConfig'

const eventData = {
    getHistory(userUuid) {
        return getNetResource(`/events/getHistory/${userUuid}`, 'get')
    },
}

export default eventData